export const defaultSeoColumns = [
  {
    title: 'Backlog',
    description: 'Tarefas que foram mapeadas e ainda serão desenvolvidas pelo time Ecto',
  },
  { title: 'Priorizados', description: 'Tarefas que estão na sprint atual do time Ecto' },
  {
    title: 'Para alinhar',
    description: 'Tarefas que precisam de alinhamento para implementação ou finalização',
  },
  {
    title: 'Entregues',
    description: 'Tarefas que precisam ser implementadas ou validadas com o time Ecto Digital',
  },
  { title: 'Finalizados', description: 'Tarefas implementadas ou finalizadas' },
  {
    title: 'Arquivados',
    description:
      'Tarefas pausadas por questões estratégicas, priorização, time ou fatores externos',
  },
];
